module.exports = __webpack_public_path__ + "static/media/logo.7a60b5d7.svg";